import PropTypes from 'prop-types'
import classes from './RunStatusBadge.module.scss'

export const RUN_STATUSES = {
  PASSED: 'Passed',
  FAILED: 'Failed',
  INCOMPLETE: 'In Progress',
  CANCELLED: 'Cancelled',
  ERROR: 'Error',
  SUCCESS: 'Success',
  STARTED: 'In Progress',
  RUNNING: 'In Progress'
}

const RunStatusBadge = ({ value }) =>
  <span className={classes.RunStatusBadge + ' ' + classes[value]}>
    {RUN_STATUSES[value]}
  </span>

RunStatusBadge.propTypes = {
  value: PropTypes.oneOf(
    Object.keys(RUN_STATUSES)
  ).isRequired
}

export default RunStatusBadge
